import { render, staticRenderFns } from "./singinheader.vue?vue&type=template&id=89db11ae&scoped=true&"
import script from "./singinheader.vue?vue&type=script&lang=js&"
export * from "./singinheader.vue?vue&type=script&lang=js&"
import style0 from "./singinheader.vue?vue&type=style&index=0&id=89db11ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89db11ae",
  null
  
)

export default component.exports